import EventDetail from "../../events/interfaces/EventDetail";
import { DUEventInfo, AccountInfo } from "../initialState";

export interface OrgProfile {
    auth_id?: string;
    email_verified?: boolean;
    email_verification_in_progress?: boolean;
    needs_change_password?: boolean;
    constituent_id?: string;
    lookup_id?: string;
    emulated_lookup_id?: string;
    constituent_last_checked?: number;
    volunteer_access?: any;
    event_coordinator?: boolean;
    loading?: boolean;
    error?: boolean;
    roles?: string;
}

export interface UIState {
    drawer_expanded?: boolean;
    is_mobile?: boolean;
}

export enum AccountTypes {
    Login = 'LOGIN',
    SetUser = 'SET_USER',
}

export enum OrgTypes {
    setProfile = 'SET_PROFILE',
}

export enum UITypes {
    setUI = 'SET_UI',
}

export enum EventTypes {
    SetOrders = 'SET_ORDERS',
    SetCurrentOrder = 'SET_CURRENT_ORDER',
    SetDetails = 'SET_DETAILS',
}

export type OrgActions =
    {
        type: 'SetProfile',
        payload: OrgProfile,
    }

export type AuthActions =
    {
        type: 'Login',
        payload: AccountInfo,
    } |
    {
        type: 'SetUser',
        payload: AccountInfo,
    }

export type UIActions =
    {
        type: 'SetUI',
        payload: UIState,
    }

export type EventActions =
    {
        type: 'SetOrders',
        payload: DUEventInfo,
    } |
    {
        type: 'SetCurrentOrder',
        payload: DUEventInfo
    } |
    {
        type: 'SetDetails',
        payload: EventDetail
    }